<form name="#searchform" (mouseover)="onMouseOver()" (mouseleave)="onMouseLeave()">
    <button class="btn btn-sm btn-custom-pri float-end" title="Search" id="{{idString}}-btn"><i
            class="fa-classic fa-solid fa-magnifying-glass fa-fw"></i></button>

    <input type="text" class="form-control form-control-sm" id="{{idString}}-box" name="{{idString}}-box"
        required (keyup)="inputKeyUp($event)" (keydown)="inputKeyDown($event)"
        [(ngModel)]="searchText" #myInputElement>
</form>